import React from 'react'
import clsx from 'clsx'

import './Input.scss'

// pass all props to the input element and define the props type

export type TPropsInput = {
  ref?: React.Ref<HTMLInputElement>
  label?: string
  error?: string
  info?: string
  type?: 'text' | 'number' | 'password' | 'email' | 'url' | 'tel' | 'search' | 'date' | 'time' | 'datetime-local'
  required?: boolean
  postfix?: string
  flexibleWidth?: boolean
  parentStyle?: React.CSSProperties
}

const Input = (props: TPropsInput & React.InputHTMLAttributes<HTMLInputElement>) => {
  const { required, flexibleWidth, ...rest } = props
  const renderedLabel = props.label ? (
    <label className="tq-input-label">
      {props.label}
      {required && <span className="tq-input-mandatory">*</span>}
    </label>
  ) : null

  return (
    <div className="tq-input-wrapper" style={props.parentStyle}>
      {renderedLabel}
      <div className={clsx('tq-input-field', { 'flexible-width': flexibleWidth })}>
        <input ref={props.ref} className={clsx('tq-input', { 'tq-input-number': props.type === 'number' })} {...rest} />
        {props.postfix && <span className="tq-input-postfix">{props.postfix}</span>}
      </div>
      {props.error && <span className="tq-input-error">{props.error}</span>}
      {props.info && <span className="tq-input-info">{props.info}</span>}
    </div>
  )
}

export default Input
